var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletterFooterHightlighted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1090_25268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9707 48.6393L14.9287 50.4035L10.8447 53.932C10.5716 54.1618 10.2386 54.3088 9.88487 54.3559C9.53111 54.4029 9.17127 54.348 8.84762 54.1976C8.52397 54.0472 8.24996 53.8076 8.05777 53.5069C7.86559 53.2062 7.76323 52.8569 7.7627 52.5V43.125",
    stroke: "#0A70B8",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7939 13.125H9.6377C9.14041 13.125 8.6635 13.3225 8.31187 13.6742C7.96024 14.0258 7.7627 14.5027 7.7627 15V33.75",
    stroke: "#E0523C",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9971 46.875H26.9814H34.9502H50.8877C51.385 46.875 51.8619 46.6775 52.2135 46.3258C52.5652 45.9742 52.7627 45.4973 52.7627 45V15C52.7627 14.5027 52.5652 14.0258 52.2135 13.6742C51.8619 13.3225 51.385 13.125 50.8877 13.125H30.2627H25.1064",
    stroke: "#F7ACB1",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1090_25268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3751 15V45C54.3751 45.9946 53.98 46.9484 53.2767 47.6516C52.5735 48.3549 51.6196 48.75 50.6251 48.75H19.4532L11.8126 55.35L11.7915 55.3664C11.1166 55.9386 10.2599 56.2519 9.37507 56.25C8.82493 56.249 8.2817 56.1274 7.78366 55.8937C7.13586 55.5952 6.58777 55.1164 6.20496 54.5145C5.82215 53.9127 5.62083 53.2133 5.62507 52.5V15C5.62507 14.0054 6.02015 13.0516 6.72342 12.3483C7.42668 11.6451 8.3805 11.25 9.37507 11.25H50.6251C51.6196 11.25 52.5735 11.6451 53.2767 12.3483C53.98 13.0516 54.3751 14.0054 54.3751 15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1090_25268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1090_25268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white",
    transform: "translate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterFooterHightlighted);
export default __webpack_public_path__ + "static/media/newsletter-footer-hightlighted.9b992d5a57a82bfe2468c34577d241f1.svg";
export { ForwardRef as ReactComponent };